//=====================================================================
// Modal, and modal component classes
//=====================================================================
export const cssClasses = {
    isActive: "isActive",
    isAnimatingIn: "isAnimatingIn",
    isAnimatingOut: "isAnimatingOut",
    modelIsVisible: "modelIsVisible"
}